import { apiUrl } from "./api";
import { fetchLatestWebfuseArticle } from "./webfuseWebhookFetch";

// --- 60s timeout + single retry-on-timeout ---
const OPENAI_TIMEOUT_MS = 60000;

function withTimeout(promise, ms) {
  return new Promise((resolve, reject) => {
    const id = setTimeout(() => reject(new Error("OPENAI_TIMEOUT")), ms);
    promise
      .then((v) => { clearTimeout(id); resolve(v); })
      .catch((e) => { clearTimeout(id); reject(e); });
  });
}

// Keep: direct call with explicit fields
export async function fetchSentimentAnalysis({ title, source, article, url, sessionId }) {
  console.log("sending request to /api/sentiment…", { hasUrl: !!url });

  // build payload safely
  const payload = { title, source, article };
  if (url) payload.url = url;
  if (sessionId) payload.sessionId = sessionId;

  const resp = await fetch(apiUrl("/api/sentiment"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err?.error || `HTTP ${resp.status}`);
  }

  return resp.json(); // -> { analysis: {...} }
}

// NEW: uses the webhook-normalized latest article as inputs
export async function fetchSentimentFromLatest() {
  const { articleTitle, articlePublication, articleContent, articleUrl } =
    await fetchLatestWebfuseArticle();

  if (!articleTitle || !articlePublication || !articleContent) {
    throw new Error("Latest webhook article is incomplete or unavailable.");
  }

  // NEW: grab the session id for server-side isolation & cache keying
  const sessionId = localStorage.getItem("newsCompare:currentSessionId") || "";

  const doCall = () =>
    fetchSentimentAnalysis({
      title: articleTitle,
      source: articlePublication,
      article: articleContent,
      url: articleUrl,
      sessionId, // <- pass it along
    });

  try {
    const data = await withTimeout(doCall(), OPENAI_TIMEOUT_MS);
    console.log("🧠 Sentiment analysis:", data);
    return data;
  } catch (err) {
    if (err?.message === "OPENAI_TIMEOUT") {
      console.warn("FLOW LOG: ⚠️ OpenAI timed out at 60s — retrying once");
      const data = await withTimeout(doCall(), OPENAI_TIMEOUT_MS);
      console.log("🧠 Sentiment analysis:", data);
      return data;
    }
    throw err;
  }
}

